<t4-header icon="glyphicon-stats"></t4-header>
  <t4-container title="{{ 'Turbo.Support.Dashboard.lblContactBrenderup' | translate : 'Contact Brenderup' }}">
    <div class="row">
      <ng-container *ngIf="Settings.clientSettings.Language == 'da'">
        <div class="box col-4">
          <h3>{{ "T4.Support.lblCall" | translate : 'Call' }}</h3>
          <div class="boxContent">
            <h3><mat-icon>call</mat-icon>+45 6342 2211</h3>
            <b>Åbningstider </b><br />
            Man - Tor: 8 - 16<br />
            Fredag: 8-15:30
          </div>
        </div>
        <div class="box col-4">
          <h3>{{ "T4.Support.lblEmail" | translate : 'Send e-mail' }}</h3>
          <div class="boxContent">
            <mat-icon>email</mat-icon> <a href="mailto:brenderuprental.dk@brenderupgroup.com" target="_blank">brenderuprental.dk&#64;brenderupgroup.com</a><br />
            <button mat-raised-button color="primary" style="margin:25px;" (click)="sendMessage()"><mat-icon>send</mat-icon> {{ "T4.Support.cmdSendMessage" | translate : 'Direct contact' }}</button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="Settings.clientSettings.Language != 'da'">
        <div class="box col-4">
          <h3>{{ "T4.Support.lblCall" | translate : 'Call' }}</h3>
          <div class="boxContent">
            <h3 *ngIf="Settings.clientSettings.Language == 'no'"><mat-icon style="margin-right: 10px;">call</mat-icon>919 00 135</h3>
            <h3 *ngIf="Settings.clientSettings.Language != 'no'"><mat-icon style="margin-right: 10px;">call</mat-icon>010 - 707 95 96</h3>
            <b>{{ "T4.Support.lblOpenHours" | translate : 'Open hours' }}</b><br />
            {{ "T4.Support.lblWeek" | translate : 'Mon-Fri' }}: 8 - 16<br />
            {{ "T4.Support.lblLunch" | translate : 'Lunch' }}: 12 - 13
          </div>
        </div>
        <div class="box col-4">
          <h3>{{ "T4.Support.lblEmail" | translate : 'Send e-mail' }}</h3>
          <div class="boxContent">
            <mat-icon style="margin-right: 10px;">email</mat-icon> <a href="mailto:info@brenderuprental.com" target="_blank">info&#64;brenderuprental.com</a><br />
            <button mat-raised-button color="primary" style="margin:25px;" (click)="sendMessage()"><mat-icon>send</mat-icon> {{ "T4.Support.cmdSendMessage" | translate : 'Direct contact' }}</button>
          </div>
        </div>
      </ng-container>
        
      <!--<div class="box col-4">
      <h3>{{ "T4.Support.lblSendLetter" | translate : 'Send letters' }}</h3>
      <div class="boxContent">
        <b>Brenderup AB</b><br />
        Transportvägen 7<br />
        553 92 Jönköping
      </div>
    </div>
  </div>
  <div class="row">
    <div class="box col-6">
      <h3>{{ "T4.Support.lblContractualIssues" | translate : 'Avtalsfrågor' }}</h3>
      <div class="boxContent">
        <div style="position: relative; display: inline-block">
          <img src="{{location?.SalesRep?.Image}}" style="height: 100px; float: left; margin:5px;" />
          <span style="display:  inline-block; margin-top: 10px; text-align:left">
            {{location?.SalesRep?.Firstname}} {{location?.SalesRep?.Lastname}}<br />
            {{location?.SalesRep?.Phone}}<br />
            <a href="mailto:{{location?.SalesRep?.Email}}" target="_blank">{{location?.SalesRep?.Email}}</a>
          </span>
        </div>
      </div>
    </div>-->
      <div class="box col-4">
        <h3>{{ "T4.Support.lblDamages" | translate : 'Damages & Insurance' }}</h3>
        <div class="boxContent" style="text-align: left;">
          <h4>{{ "T4.Support.lblDamageDetails" | translate : 'Damages' }}</h4>
          <ol>
            <li>{{ "T4.Support.lblRegisterIssue" | translate : 'Register an issue, and disable the trailer in T4' }}</li>
            <li>{{ "T4.Support.lblContactServicePartner" | translate : 'Contact your service partner for further assistance.' }}</li>
          </ol>

          <h4>{{ "T4.Support.lblInsuranceDetails" | translate : 'Insurance' }}</h4>
          <ol>
            <li>{{ "T4.Support.lblReportStolen" | translate : 'Report the trailer as stolen if necessary' }}</li>
            <li>{{ "T4.Support.lblRegisterIssue" | translate : 'Register an issue, and disable the trailer in T4' }}</li>
            <li>{{ "T4.Support.lblInsuranceReport" | translate : 'Mark the issue as an insurance request and follow the instructions in T4.' }}</li>
          </ol>
        </div>
      </div>
    </div>
  </t4-container>
